import { useState } from 'react';
import { sendContactMessage } from '../services/api';
import { useAuth } from '../lib/auth';

const ContactForm = () => {
  const { user, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({
    name: user ? user.firstName : '',
    email: user ? user.email : '',
    phone: '',
    subject: '',
    message: '',
    followUp: false,
  });
  const [status, setStatus] = useState('');

  // Gérer les changements des champs du formulaire
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // Soumettre le formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isAuthenticated) {
      setStatus('Vous devez être connecté pour envoyer un message.');
      return;
    }

    try {
      await sendContactMessage(formData);
      setStatus('Message envoyé avec succès.');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '', followUp: false });
    } catch (error) {
      console.error("Erreur lors de l'envoi du message:", error);
      setStatus("Erreur lors de l'envoi du message.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <h2>Contactez-nous</h2>
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="Nom"
        required
      />
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email"
        required
      />
      <input
        type="text"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        placeholder="Téléphone"
      />
      <input
        type="text"
        name="subject"
        value={formData.subject}
        onChange={handleChange}
        placeholder="Sujet"
      />
      <textarea
        name="message"
        value={formData.message}
        onChange={handleChange}
        placeholder="Votre message"
        required
      />
      <label>
        <input
          type="checkbox"
          name="followUp"
          checked={formData.followUp}
          onChange={handleChange}
        />
        Suivi demandé
      </label>
      <button type="submit">Envoyer</button>
      {status && <p>{status}</p>}
    </form>
  );
};

export default ContactForm;
